import { render, staticRenderFns } from "./ClubContacts.vue?vue&type=template&id=24bf793a"
import script from "./ClubContacts.vue?vue&type=script&lang=js"
export * from "./ClubContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports